import '../main.js'

const loginPanel = document.querySelector('#login-panel')
const uploadPanel = document.querySelector('#upload-panel')
const loginForm = document.querySelector('#login-form')
const uploadForm = document.querySelector('#upload-form')
const message = document.querySelector('#message')
let csrfToken = ''
let maxUploadBytes = 10 * 1024 * 1024

function showMessage(text, success = false) {
	message.textContent = text
	message.className = `alert status-message ${success ? 'alert-success' : 'alert-danger'}`
}

function showPanels(authenticated) {
	loginPanel.hidden = authenticated
	uploadPanel.hidden = !authenticated
}

async function request(path, options = {}) {
	const response = await fetch(path, {
		credentials: 'same-origin', cache: 'no-store', ...options,
		headers: { 'X-CSRF-Token': csrfToken, ...options.headers }
	})
	let data
	try { data = await response.json() } catch { throw new Error('The server could not be reached. Refresh and try again.') }
	if (!response.ok) {
		const error = new Error(data.error || 'The request failed.')
		error.status = response.status
		throw error
	}
	return data
}

function renderCv(cv) {
	document.querySelector('#current-cv').textContent = cv.available
		? `Last updated ${new Date(cv.updatedAt).toLocaleString()} · ${(cv.size / 1024).toFixed(0)} KB`
		: 'No CV has been uploaded yet.'
	document.querySelector('#current-link').hidden = !cv.available
}

async function refreshSession() {
	const data = await request('/api/session')
	csrfToken = data.csrfToken
	maxUploadBytes = data.maxUploadBytes
	showPanels(data.authenticated)
	if (data.authenticated) renderCv(await request('/api/cv'))
}

async function recover(error) {
	if (error.status === 401 || error.status === 403) {
		try { await refreshSession() } catch {}
	}
	showMessage(error.message)
}

loginForm.addEventListener('submit', async event => {
	event.preventDefault()
	const button = loginForm.querySelector('button')
	button.disabled = true
	button.textContent = 'Signing in…'
	showMessage('')
	try {
		const data = await request('/api/login', {
			method: 'POST', headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ password: document.querySelector('#password').value })
		})
		csrfToken = data.csrfToken
		loginForm.reset()
		showPanels(true)
		renderCv(await request('/api/cv'))
		document.querySelector('#cv').focus()
	} catch (error) { await recover(error) } finally {
		button.disabled = false
		button.textContent = 'Sign in'
	}
})

uploadForm.addEventListener('submit', async event => {
	event.preventDefault()
	const file = document.querySelector('#cv').files[0]
	if (!file || !/\.pdf$/i.test(file.name)) return showMessage('Choose a PDF file.')
	if (file.size > maxUploadBytes) return showMessage('The PDF must be smaller than 10 MB.')
	const button = uploadForm.querySelector('button')
	const logout = document.querySelector('#logout')
	button.disabled = logout.disabled = true
	button.textContent = 'Uploading…'
	showMessage('')
	try {
		const data = await request('/api/cv', { method: 'POST', body: new FormData(uploadForm) })
		renderCv(data)
		uploadForm.reset()
		showMessage('Your CV has been updated.', true)
	} catch (error) { await recover(error) } finally {
		button.disabled = logout.disabled = false
		button.textContent = 'Upload CV'
	}
})

document.querySelector('#logout').addEventListener('click', async event => {
	const button = event.currentTarget
	button.disabled = true
	try {
		await request('/api/logout', { method: 'POST' })
		uploadForm.reset()
		await refreshSession()
		showMessage('You have signed out.', true)
		document.querySelector('#password').focus()
	} catch (error) { await recover(error) } finally { button.disabled = false }
})

refreshSession().catch(error => showMessage(error.message)).finally(() => {
	document.querySelector('#initial-status').hidden = true
})
